module.exports = __webpack_public_path__ + "f09b4982b2a3d3021077eebdb667946b.svg";